var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { BlameLogType } from '@debbie/common/dist/blamelog';
import THEME from '../../../theme';
import DateInput from '../../DateInput';
import UserInfoEntity from './UserInfoEntity';
const UserBirthdate = (props) => {
    const { details } = props.user;
    const lang = useSelector((s) => s.lang);
    const [birthdate, setBirthdate] = useState(null);
    useEffect(() => {
        if (details) {
            if (!birthdate && details.birthdate) {
                setBirthdate(moment(details.birthdate));
            }
        }
    }, [details]);
    return !props.customer.isCompany &&
        props.user.relation !== 'alternative-contact' ? (React.createElement(UserInfoEntity, { title: lang.debtorInfo.birthdate, value: birthdate, onChange: (val) => __awaiter(void 0, void 0, void 0, function* () { }), renderValue: () => birthdate ? (`${birthdate.format(THEME.DATE_FORMAT)} (${moment().diff(birthdate, 'years')} ${lang.debtorInfo.yearsOld})`) : (React.createElement("span", { style: { opacity: 0.5 } }, lang.debtorInfo.noBirthdate)), renderEditor: (selectedValue) => (React.createElement(DateInput, { allowNull: true, onChange: (val) => __awaiter(void 0, void 0, void 0, function* () {
                setBirthdate(val);
                if (val == null || (val != null && val.isValid())) {
                    yield props.patchUser({
                        birthdate: val ? val.format() : null,
                    }, {
                        details: val ? val.format() : null,
                        type: BlameLogType.DebtorUpdateBirthdate,
                    });
                    selectedValue(val);
                }
            }), value: birthdate ? birthdate : moment(), placeholder: lang.debtorInfo.birthdate, maxDate: new Date(), customDateFormat: "dd.MM.yyyy" })), removable: true })) : null;
};
export default UserBirthdate;
//# sourceMappingURL=UserBirthdate.js.map